import React, { useEffect, useState } from "react";
import { MdEmail } from "react-icons/md";
import { IoMdPhonePortrait } from "react-icons/io";
import { FaFacebookF, FaList, FaLock, FaUser } from "react-icons/fa";
import { IoMdArrowDropdown } from "react-icons/io";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaHeart } from "react-icons/fa6";
import { FaCartShopping } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
  get_card_products,
  get_wishlist_products,
} from "../store/reducers/cardReducer";
import { MdLanguage } from "react-icons/md";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categorys } = useSelector((state) => state.home);
  const { userInfo } = useSelector((state) => state.auth);
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );
  const { pathname } = useLocation();

  const [showSidebar, setShowSidebar] = useState(false);
  const [categoryShow, setCategoryShow] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [category, setCategory] = useState("");

  const search = () => {
    navigate(`/products/search?category=${category}&&value=${searchValue}`);
  };

  const redirect_card_page = () => {
    if (userInfo) {
      navigate("/card");
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    if (userInfo) {
      dispatch(get_wishlist_products(userInfo.id));
    }
  }, [userInfo, dispatch]);

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (showSidebar && !e.target.closest(".mobile-sidebar")) {
        setShowSidebar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showSidebar]);

  useEffect(() => {
    dispatch(get_card_products(userInfo.id));
  }, [dispatch, userInfo.id]);

  return (
    <div className="w-full bg-[#f3f6fa] pb-3">
      {/* Top Bar */}
      <div className="bg-[#caddff] hidden md:block">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-12">
            {/* Contact Info */}
            <ul className="flex items-center space-x-6 text-sm">
              <li className="flex items-center space-x-2">
                <MdEmail />
                <span>danypadillab43@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <IoMdPhonePortrait />
                <span>9851 - 1183</span>
              </li>
            </ul>

            {/* Right Side Menu */}
            <div className="flex items-center space-x-6">
              <a
                href="https://www.facebook.com/profile.php?id=100063564433097"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF className="text-black hover:text-[#059473] transition-colors duration-200" />
              </a>

              {/* Language Selector */}
              <div className="relative group">
                <button className="flex items-center space-x-1 text-sm hover:text-[#059473] transition-colors duration-200">
                  <MdLanguage />
                  <IoMdArrowDropdown className="transform group-hover:rotate-180 transition-transform duration-200" />
                </button>
                <ul className="absolute opacity-0 invisible group-hover:opacity-100 group-hover:visible bg-black text-white py-2 px-4 rounded-md -left-4 mt-2 transition-all duration-200 ease-in-out transform group-hover:translate-y-0 translate-y-2">
                  <li className="hover:text-[#059473] transition-colors duration-200">
                    Español
                  </li>
                </ul>
              </div>

              {/* Auth Link */}
              {userInfo ? (
                <Link
                  to="/dashboard"
                  className="flex items-center space-x-2 text-sm hover:text-[#059473] transition-colors duration-200"
                >
                  <FaUser />
                  <span>{userInfo.name}</span>
                </Link>
              ) : (
                <Link
                  to="/login"
                  className="flex items-center space-x-2 text-sm hover:text-[#059473] transition-colors duration-200"
                >
                  <FaLock />
                  <span>Iniciar Sesión</span>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          {/* Logo */}
          <div className="flex items-center justify-between w-full md:w-auto">
            <Link
              to="/"
              className="transition-transform duration-200 hover:scale-105"
            >
              <img
                src="https://diarcel.com/images/logo.png"
                alt="Logo"
                className="h-16"
              />
            </Link>
            <button
              className="md:hidden p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
              onClick={() => setShowSidebar(true)}
            >
              <FaList className="text-2xl" />
            </button>
          </div>

          {/* Navigation */}
          <nav className="hidden md:block">
            <ul className="flex space-x-8 text-sm font-bold uppercase">
              {[
                { path: "/", label: "Inicio" },
                { path: "/shops", label: "Tienda" },
                { path: "/blog", label: "Noticias" },
                { path: "/about", label: "Sobre Nosotros" },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`${
                      pathname === item.path
                        ? "text-[#059473]"
                        : "text-slate-600"
                    } hover:text-[#059473] transition-colors duration-200 relative after:absolute after:left-0 after:bottom-0 after:h-0.5 after:w-0 after:bg-[#059473] after:transition-all after:duration-200 hover:after:w-full`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Cart and Wishlist */}
          <div className="hidden md:flex items-center space-x-4">
            <button
              onClick={() =>
                navigate(userInfo ? "/dashboard/my-wishlist" : "/login")
              }
              className="relative p-2 bg-[#e2e2e2] rounded-full hover:bg-[#d1d1d1] transition-colors duration-200 transform hover:scale-105"
            >
              <FaHeart className="text-green-600 text-xl" />
              {wishlist_count > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs">
                  {wishlist_count}
                </span>
              )}
            </button>

            <button
              onClick={redirect_card_page}
              className="relative p-2 bg-[#e2e2e2] rounded-full hover:bg-[#d1d1d1] transition-colors duration-200 transform hover:scale-105"
            >
              <FaCartShopping className="text-green-600 text-xl" />
              {card_product_count > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs">
                  {card_product_count}
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Search and Categories */}
        <div className="mt-4 flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8">
          {/* Categories */}
          <div className="w-full md:w-3/12 relative">
            {" "}
            {/* Added relative positioning */}
            <button
              onClick={() => setCategoryShow(!categoryShow)}
              className="w-full bg-[#059473] text-white p-3 rounded-md flex items-center justify-between hover:bg-[#048265] transition-colors duration-200"
            >
              <span className="flex items-center space-x-2">
                <FaList />
                <span>Categorias</span>
              </span>
              <IoIosArrowDown
                className={`transform transition-transform duration-200 ${
                  categoryShow ? "rotate-180" : ""
                }`}
              />
            </button>
            {/* Category Dropdown - Updated positioning */}
            <div
              className={`absolute w-full z-50 transform transition-all duration-300 ease-in-out ${
                categoryShow
                  ? "opacity-100 translate-y-0 visible"
                  : "opacity-0 -translate-y-4 invisible"
              } mt-1 bg-[#dbf3ed] border rounded-md overflow-hidden shadow-lg`}
            >
              <ul className="py-2 max-h-[400px] overflow-y-auto">
                {categorys.map((c, i) => (
                  <li
                    key={i}
                    className="px-4 py-2 hover:bg-[#c5e8e0] transition-colors duration-200"
                  >
                    <Link
                      to={`/products?category=${c.name}`}
                      className="flex items-center space-x-2"
                      onClick={() => setCategoryShow(false)} // Close dropdown when selecting a category
                    >
                      <img
                        src={c.image}
                        alt={c.name}
                        className="w-8 h-8 rounded-full transition-transform duration-200 hover:scale-110"
                      />
                      <span className="text-sm">{c.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* Search */}
          <div className="flex-1">
            <div className="flex">
              <select
                onChange={(e) => setCategory(e.target.value)}
                className="hidden md:block w-32 border-y border-l border-gray-300 rounded-l-md px-3 focus:outline-none focus:border-[#059473] transition-colors duration-200"
              >
                <option value="">Filtrar</option>
                {categorys.map((c, i) => (
                  <option key={i} value={c.name}>
                    {c.name}
                  </option>
                ))}
              </select>
              <input
                type="text"
                placeholder="Que estas buscando?"
                className="flex-1 border border-gray-300 p-3 outline-none focus:border-[#059473] transition-colors duration-200"
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    search();
                  }
                }}
              />
              <button
                onClick={search}
                className="bg-[#595e5d] text-white px-8 rounded-r-md hover:bg-[#484c4b] transition-colors duration-200"
              >
                Buscar
              </button>
            </div>
          </div>
          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="w-12 h-12 bg-[#f5f5f5] rounded-full flex items-center justify-center transform hover:scale-105 transition-transform duration-200">
              <FaPhoneAlt />
            </div>
            <div>
              <p className="font-medium">9851 - 1183</p>
              <p className="text-sm text-gray-600">8:00 AM a 5:00 PM</p>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div
        className={`fixed inset-0 z-40 transition-opacity duration-300 ${
          showSidebar ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-300"
          onClick={() => setShowSidebar(false)}
        />
        <div
          className={`mobile-sidebar fixed inset-y-0 left-0 w-64 bg-white z-50 p-6 overflow-y-auto transform transition-transform duration-300 ease-in-out ${
            showSidebar ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex flex-col space-y-6">
            <Link
              to="/"
              className="mb-6 transition-transform duration-200 hover:scale-105"
            >
              <img
                src="https://diarcel.com/images/logo.png"
                alt="Logo"
                className="h-16"
              />
            </Link>
            {/* Cart and Wishlist */}
            <div className="flex items-center space-x-4">
              <button
                onClick={() =>
                  navigate(userInfo ? "/dashboard/my-wishlist" : "/login")
                }
                className="relative p-2 bg-[#e2e2e2] rounded-full hover:bg-[#d1d1d1] transition-colors duration-200 transform hover:scale-105"
              >
                <FaHeart className="text-green-600 text-xl" />
                {wishlist_count > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs">
                    {wishlist_count}
                  </span>
                )}
              </button>

              <button
                onClick={redirect_card_page}
                className="relative p-2 bg-[#e2e2e2] rounded-full hover:bg-[#d1d1d1] transition-colors duration-200 transform hover:scale-105"
              >
                <FaCartShopping className="text-green-600 text-xl" />
                {card_product_count > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs">
                    {card_product_count}
                  </span>
                )}
              </button>
            </div>

            <ul className="flex flex-col space-y-4">
              {[
                { path: "/", label: "Inicio" },
                { path: "/shops", label: "Tienda" },
                { path: "/blog", label: "Noticias" },
                { path: "/about", label: "Sobre Nosotros" },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`${
                      pathname === item.path
                        ? "text-[#059473]"
                        : "text-slate-600"
                    } hover:text-[#059473] transition-colors duration-200`}
                    onClick={() => setShowSidebar(false)}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Auth Link */}
            {userInfo ? (
              <Link
                to="/dashboard"
                className="flex items-center space-x-2 text-sm hover:text-[#059473] transition-colors duration-200"
              >
                <FaUser />
                <span>{userInfo.name}</span>
              </Link>
            ) : (
              <Link
                to="/login"
                className="flex items-center space-x-2 text-sm hover:text-[#059473] transition-colors duration-200"
              >
                <FaLock />
                <span>Iniciar Sesión</span>
              </Link>
            )}

            <div className="flex items-center space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=100063564433097"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#059473] transition-colors duration-200"
              >
                <FaFacebookF />
              </a>
            </div>

            <div className="pt-6 border-t">
              <p className="text-sm font-medium">9851 - 1183</p>
              <p className="text-xs text-gray-600">8:00 AM a 5:00 PM</p>
              <p className="text-sm mt-2">danypadillab43@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
